import {
  ESTABLISH_STATES_DEVICE,
  SELECT_DEVICE,
  UPDATE_DEVICE,
  CREATE_TRAY,
  EDIT_TRAY,
  FETCH_TRAY,
  FETCH_TRAYS,
  DELETE_TRAY,
  UPDATE_SPECIMEN_FROM_METADATA,
  UPDATE_TRAY_FROM_METADATA,
  UPDATE_SPECIMEN_AUTO_METADATA,
  RELOAD_SOCKET,
  CLEAR_TRAY,
  FETCH_DEVICE_MAC_ADDRESS,
  FETCH_DEVICE_MAC_ADDRESS_RESPONSE,
  FINISH_FETCH_MAC_ADDRESS,
  MOVE_DEVICE_ORG,
  RENAME_DEVICE,
  UPDATE_DEVICE_ENV,
  UPDATE_DEVICE_VECTOR_TYPE,
  CHANGE_DEVICE_HARDWARE_ID,
  NETWORK_METRICS,
  DELETE_WIFI_RESPONSE,
  SET_DEVICES_INFOS,
} from "../actions/types";
import { camelify } from "./../utils/caseConvert";
import _ from "lodash";
import trayReducer from "./trayReducer";

/* eslint import/no-anonymous-default-export: [2, {"allowArrowFunction": true}] */
export default (
  state = { fetchingMacAddressStatus: "disconnected" },
  action
) => {
  let device_uuid;
  let old;
  switch (action.type) {
    case ESTABLISH_STATES_DEVICE:
      const devices = {
        ...Object.fromEntries(
          Object.entries(action.payload?.initial_states).map(([k, v]) => [
            k,
            { ...camelify(v), uuid: k },
          ])
        ),
        ALLTRAY: {
          id: "ALLTRAY",
          displayName: "all devices",
          uuid: "ALLTRAY",
          env: "ALLTRAY",
        },
      };
      return _.defaultsDeep({}, devices, state);
    case UPDATE_DEVICE_ENV:
      if (action.payload?.deviceUuid && action.payload?.env) {
        return _.defaultsDeep(
          {},
          { [action.payload.deviceUuid]: { env: action.payload.env } },
          state
        );
      }
      return state;
    case UPDATE_DEVICE_VECTOR_TYPE:
      if (action.payload?.deviceUuid && action.payload?.vectorType) {
        return _.defaultsDeep(
          {},
          {
            [action.payload.deviceUuid]: {
              vectorType: action.payload.vectorType,
            },
          },
          state
        );
      }
      return state;
    case SELECT_DEVICE:
      if (action.payload === "none") return _.omit(state, "selectedDevice");
      return { ...state, selectedDevice: action.payload };
    case UPDATE_DEVICE:
      const {
        device_uuid: uuid,
        metadata = {},
        ...otherProps
      } = action.payload;

      if (uuid) {
        // update only if incoming timestamp is newer than current timestamp
        // otherwise keep current value
        const [updatedProps, updatedMetadata] = Object.entries({
          ...otherProps,
        }).reduce(
          (o, [key, value]) => {
            if (value !== undefined) {
              if (
                (metadata?.[key]?.timestamp || 0) >=
                (state?.[uuid]?.metadata?.[key] || 0)
              ) {
                return [
                  [...o[0], [key, value]],
                  [...o[1], [key, metadata?.[key]?.timestamp || 0]],
                ];
              } else {
                return [
                  [...o[0], [key, state?.[uuid]?.[key]]],
                  [...o[1], [key, state?.[uuid]?.metadata?.[key] || 0]],
                ];
              }
            }

            return o;
          },
          [[], []]
        );

        return _.defaultsDeep(
          {},
          {
            [uuid]: camelify({
              ...Object.fromEntries(updatedProps),
              metadata: Object.fromEntries(updatedMetadata),
            }),
          },
          state
        );
      }
      return state;
    case UPDATE_SPECIMEN_FROM_METADATA:
    case UPDATE_SPECIMEN_AUTO_METADATA:
    case UPDATE_TRAY_FROM_METADATA:
    case FETCH_TRAYS:
    case CREATE_TRAY:
    case FETCH_TRAY:
    case EDIT_TRAY:
    case DELETE_TRAY:
      device_uuid = state?.selectedDevice;
      if (action.type === FETCH_TRAYS) {
        device_uuid = action.payload?.deviceUuid;
        action.payload = _.omit(action.payload, ["deviceUuid"]);
      }
      if (!device_uuid) return state;
      old = { ...state?.[device_uuid] };
      return {
        ...state,
        [device_uuid]: { ...old, trays: trayReducer(old?.trays, action) },
      };
    case MOVE_DEVICE_ORG:
      if (action.payload.device in state) {
        return Object.fromEntries(
          Object.entries(state).filter(
            ([deviceUuid, v]) => deviceUuid !== action.payload.device
          )
        );
      }
      return state;
    case RENAME_DEVICE:
      if (action.payload.device in state) {
        return {
          ...state,
          [action.payload.device]: {
            ...state?.[action.payload.device],
            displayName: action.payload.name,
          },
        };
      }
      return state;
    // case EDIT_SPECIMEN:
    //     device_uuid = state?.selectedDevice;
    //     if (!device_uuid) return state;
    //     old = { ...state?.[device_uuid] }
    //     return _.defaultsDeep({}, { [device_uuid]: { trays: { [action.payload.tray_id]: { specimens: specimenReducer(old.trays.specimens, action) } } } }, state)
    case CHANGE_DEVICE_HARDWARE_ID:
      if (action.payload.device in state) {
        return {
          ...state,
          [action.payload.device]: {
            ...state?.[action.payload.device],
            hardware_id: action.payload.hardwareId,
          },
        };
      }
      return state;
    case CLEAR_TRAY:
      device_uuid = action.payload?.deviceUuid;
      old = { ...state?.[device_uuid] };
      return {
        ...state,
        [device_uuid]: { ...old, trays: [] },
      };
    case FETCH_DEVICE_MAC_ADDRESS:
      return { ...state, fetchingMacAddressStatus: "fetching" };
    case FETCH_DEVICE_MAC_ADDRESS_RESPONSE:
      device_uuid = action.payload?.device_uuid;
      const macAddress = action.payload?.macAddress;
      old = { ...state?.[device_uuid] };
      return {
        ...state,
        [device_uuid]: { ...old, macAddress: macAddress },
        fetchingMacAddressStatus: "ready",
      };
    case FINISH_FETCH_MAC_ADDRESS:
      return {
        ...state,
        fetchingMacAddressStatus: "disconnected",
      };
    case RELOAD_SOCKET:
      return {};
    case NETWORK_METRICS:
      if (action.payload?.deviceUuid) {
        return _.defaultsDeep(
          {},
          {
            [action.payload.deviceUuid]: {
              networkMetrics: _.omit(action.payload, "deviceUuid"),
            },
          },
          state
        );
      }
      return state;
    case DELETE_WIFI_RESPONSE:
      return {
        ...state,
        [state.selectedDevice]: {
          ...state[state.selectedDevice],
          stateMachine: "OFF",
        },
      };
    case SET_DEVICES_INFOS:
      const updatedDevices = action.payload.tools.reduce(
        (acc, tool) => {
          // Merge existing device info with new info, or just add the new info
          acc[tool.uuid] = {
            ...(state[tool.uuid] || {}), // Use 'state' here to access potentially existing data
            hardwareId: tool?.["hardware_id"],
          };
          return acc;
        },
        { ...state }
      ); // Start the accumulator with a shallow copy of the current state

      return updatedDevices;
    default:
      return state;
  }
};
